module.exports = __webpack_public_path__ + "static/media/menu1_cont_01.ba05afcb.png";